import { type PropsWithChildren } from 'react';

import { SynchronizedCrosshairProvider } from './providers/SynchronizedCrosshairProvider.js';
import { SynchronizedSelectionProvider } from './providers/SynchronizedSelectionProvider.js';

/**
 * The Shared Chart Interactions Component
 * @public
 */
export const SharedChartInteractions = ({ children }: PropsWithChildren) => {
  return (
    <SynchronizedCrosshairProvider>
      <SynchronizedSelectionProvider>{children}</SynchronizedSelectionProvider>
    </SynchronizedCrosshairProvider>
  );
};

SharedChartInteractions['displayName'] = 'SharedChartInteractions';
